<template>
  <div class="customer-editor">

      <el-form :model="form" ref="form" :label-width="width">

        <el-row :gutter="0">

          <el-col :span="11">

            <el-form-item label="企业名称" prop="name">
              <el-input v-model="form.name" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.name, old_form.name)" v-model="old_form.name" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="法人代表">
              <el-input v-model="form.legal_person" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.legal_person, old_form.legal_person)" v-model="old_form.legal_person" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="注册资金">
              <el-input v-model="form.registered_captial" autocomplete="off" size="mini" readonly>
                <template slot="append">万元</template>
              </el-input>
              <el-input v-if="diffData(form.registered_captial, old_form.registered_captial)" v-model="old_form.registered_captial" autocomplete="off" size="mini" readonly class="diff-form">
                <template slot="append">万元</template>
              </el-input>
            </el-form-item>

            <el-form-item label="营业期限">
              <el-input v-model="form.business_term" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.business_term, old_form.business_term)" v-model="old_form.business_term" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="企业开户行">
              <el-input v-model="form.bank_name" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.bank_name, old_form.bank_name)" v-model="old_form.bank_name" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="企业地址">
              <el-input v-model="form.address" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.address, old_form.address)" v-model="old_form.address" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="营业执照">
              <el-input v-model="form.business_license" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.business_license, old_form.business_license)" v-model="old_form.business_license" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="注册地址">
              <el-input v-model="form.registered_address" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.registered_address, old_form.registered_address)" v-model="old_form.registered_address" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="联系人姓名">
              <el-input v-model="form.contact_name" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.contact_name, old_form.contact_name)" v-model="old_form.contact_name" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="电子邮箱">
              <el-input v-model="form.email" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.email, old_form.email)" v-model="old_form.email" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="通信地址">
              <el-input v-model="form.post_address" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.post_address, old_form.post_address)" v-model="old_form.post_address" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="邮政编码">
              <el-input v-model="form.post_code" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.post_code, old_form.post_code)" v-model="old_form.post_code" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="客户类型" prop="type">
              <el-checkbox-group v-model="form.type" size="mini" readonly>
                <el-checkbox label="1" disabled>业主</el-checkbox>
                <el-checkbox label="2" disabled>租户</el-checkbox>
                <el-checkbox label="3">住户</el-checkbox>
                <el-checkbox label="4">共有人</el-checkbox>
                <el-checkbox label="5">开发商</el-checkbox>
                <el-checkbox label="9">其它</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-if="diffData(form.type, old_form.type)" v-model="old_form.type" size="mini" readonly class="diff-form">
                <el-checkbox label="1" disabled>业主</el-checkbox>
                <el-checkbox label="2" disabled>租户</el-checkbox>
                <el-checkbox label="3">住户</el-checkbox>
                <el-checkbox label="4">共有人</el-checkbox>
                <el-checkbox label="5">开发商</el-checkbox>
                <el-checkbox label="9">其它</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="特殊身份" :label-width="width">
              <el-select v-model="form.special" placeholder="请选择" size="mini" readonly>
                <el-option v-for="item in specialList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-if="diffData(form.special, old_form.special)" v-model="old_form.special" placeholder="请选择" size="mini" readonly class="diff-form">
                <el-option v-for="item in specialList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="发票抬头">
              <el-input v-model="form.invoice_title" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.invoice_title, old_form.invoice_title)" v-model="old_form.invoice_title" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="信用额度">
              <el-input v-model="form.credit_limit" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.credit_limit, old_form.credit_limit)" v-model="old_form.credit_limit" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>



          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="11">

            <el-form-item label="统一社会信用代码">
              <el-input v-model="form.business_code" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.business_code, old_form.business_code)" v-model="old_form.business_code" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="成立日期	" :label-width="width">
              <el-date-picker v-model="form.establishment_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" size="mini" readonly></el-date-picker>
              <el-date-picker v-if="diffData(form.establishment_date, old_form.establishment_date)" v-model="old_form.establishment_date" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" size="mini" readonly class="diff-form"></el-date-picker>
            </el-form-item>

            <el-form-item label="经营范围">
              <el-input type="textarea" v-model="form.business_scope" size="mini" readonly></el-input>
              <el-input type="textarea" v-if="diffData(form.business_scope, old_form.business_scope)" v-model="old_form.business_scope" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="企业开户帐号">
              <el-input v-model="form.bank_account" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.bank_account, old_form.bank_account)" v-model="old_form.bank_account" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="企业电话">
              <el-input v-model="form.business_tel" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.business_tel, old_form.business_tel)" v-model="old_form.business_tel" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="业主IC卡">
              <el-input v-model="form.ic_card" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.ic_card, old_form.ic_card)" v-model="old_form.ic_card" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="企业性质">
              <el-select v-model="form.enterprise_class" placeholder="请选择" size="mini" readonly>
                <el-option v-for="item in classList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-if="diffData(form.enterprise_class, old_form.enterprise_class)" v-model="old_form.enterprise_class" placeholder="请选择" size="mini" readonly class="diff-form">
                <el-option v-for="item in classList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所属组织">
<!--              <el-input v-model="form.organization" autocomplete="off"></el-input>-->
              <el-select v-model="form.organization_project_id" clearable filterable placeholder="所属组织" size="mini" readonly>
                <el-option
                  v-for="item in project_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <el-select v-if="diffData(form.organization_project_id, old_form.organization_project_id)" v-model="old_form.organization_project_id" clearable filterable placeholder="所属组织" size="mini" readonly class="diff-form">
                <el-option
                  v-for="item in project_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="联系电话">
              <el-input v-model="form.contact_number" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.contact_number, old_form.contact_number)" v-model="old_form.contact_number" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="移动电话">
              <el-input v-model="form.phone_number" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.phone_number, old_form.phone_number)" v-model="old_form.phone_number" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="传真">
              <el-input v-model="form.fax" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.fax, old_form.fax)" v-model="old_form.fax" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="产权性质">
              <el-checkbox-group v-model="form.property_type" size="mini" readonly>
                <el-checkbox label="1">产权</el-checkbox>
                <el-checkbox label="2">产权人亲属</el-checkbox>
                <el-checkbox label="3">承租人</el-checkbox>
              </el-checkbox-group>
              <el-checkbox-group v-if="diffData(form.property_type, old_form.property_type)" v-model="old_form.property_type" size="mini" readonly class="diff-form">
                <el-checkbox label="1">产权</el-checkbox>
                <el-checkbox label="2">产权人亲属</el-checkbox>
                <el-checkbox label="3">承租人</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="客户分类">
              <el-select v-model="form.category" placeholder="请选择" size="mini" readonly>
                <el-option label="特别重要客户★★★★★" value="1"></el-option>
                <el-option label="重要客户★★★★" value="2"></el-option>
                <el-option label="普通客户★★★" value="3"></el-option>
                <el-option label="问题客户★★" value="4"></el-option>
                <el-option label="劣质客户★" value="5"></el-option>
              </el-select>
              <el-select v-if="diffData(form.category, old_form.category)" v-model="old_form.category" placeholder="请选择" size="mini" readonly class="diff-form">
                <el-option label="特别重要客户★★★★★" value="1"></el-option>
                <el-option label="重要客户★★★★" value="2"></el-option>
                <el-option label="普通客户★★★" value="3"></el-option>
                <el-option label="问题客户★★" value="4"></el-option>
                <el-option label="劣质客户★" value="5"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="企业税号">
              <el-input v-model="form.tax_code" autocomplete="off" size="mini" readonly></el-input>
              <el-input v-if="diffData(form.tax_code, old_form.tax_code)" v-model="old_form.tax_code" autocomplete="off" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="备注">
              <el-input type="textarea" v-model="form.remark" size="mini" readonly></el-input>
              <el-input type="textarea" v-if="diffData(form.remark, old_form.remark)" v-model="old_form.remark" size="mini" readonly class="diff-form"></el-input>
            </el-form-item>

            <el-form-item label="附件" :label-width="width">
              <el-upload ref="upload" :action="uploadUrl" :on-preview="filePreview" :on-remove="uploadRemove" :file-list="form.attachment" :auto-upload="false" :on-success="uploadSuccess" :data="uploadData">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传</el-button>
                <div slot="tip" class="el-upload__tip">文件大小不超过1M</div>
              </el-upload>
            </el-form-item>

          </el-col>

        </el-row>

        <el-divider></el-divider>

        <el-row :gutter="0">
          <el-col :span="24">
            <div class="member-title">企业主要负责人</div>

            <el-table :data="form.members" border style="width: 100%;margin-bottom: 20px;">
              <el-table-column prop="name" label="姓名(必填)">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="sex" label="性别" width="100">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.sex" placeholder="请选择">
                    <el-option label="男" value="1"></el-option>
                    <el-option label="女" value="2"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="birthday" label="出生年月" width="150">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column prop="job" label="	职务">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.job" autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="id_code" label="身份证号">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.id_code" autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="contact_number" label="联系电话">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.contact_number" autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="interest" label="兴趣爱好">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.interest" autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="学历职称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.title" autocomplete="off"></el-input>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
        </el-row>


      </el-form>

  </div>
</template>

<script>

  import Common from '../../common.js'

  export default {
    name: "enterprise-preview",
    props: {
      width: {
        type: String,
        default() {
          return '130px'
        }
      },
      form_data: {
        type: Object,
        default() {
          return {}
        }
      },
      form_old_data: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    data(){
      return{
        loading: false,
        form: this.getFormData({}),
        old_form: this.getFormData({}),
        rules: {
          name: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
            { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          type: [
            { type: 'array', required: true, message: '请至少选择一个客户类型', trigger: 'change' }
          ],
        },
        specialList: [{"value":"1","label":"地市级政府官员"},{"value":"2","label":"物业管理行业主管领导"},{"value":"3","label":"大型公司/地产公司董事长"},{"value":"4","label":"大型公司/地产公司总裁"},{"value":"5","label":"大型公司/地产公司总经理"},{"value":"6","label":"知名媒体人士"},{"value":"7","label":"影视明星"},{"value":"8","label":"业委会主任/副主任"},{"value":"9","label":"社区主任"},{"value":"10","label":"物业管理行业领导"},{"value":"11","label":"派出所领导"},{"value":"12","label":"一般公司董事长"},{"value":"13","label":"一般公司总裁"},{"value":"14","label":"一般公司总经理"},{"value":"15","label":"地产公司物业对接人"},{"value":"16","label":"业委会成员"},{"value":"17","label":"热心业户"}],
        classList: [{"value":"1","label":"地市级政府官员"},{"value":"2","label":"物业管理行业主管领导"},{"value":"3","label":"大型公司/地产公司董事长"},{"value":"4","label":"大型公司/地产公司总裁"},{"value":"5","label":"大型公司/地产公司总经理"},{"value":"6","label":"知名媒体人士"},{"value":"7","label":"影视明星"},{"value":"8","label":"业委会主任/副主任"},{"value":"9","label":"社区主任"},{"value":"10","label":"物业管理行业领导"},{"value":"11","label":"派出所领导"},{"value":"12","label":"一般公司董事长"},{"value":"13","label":"一般公司总裁"},{"value":"14","label":"一般公司总经理"},{"value":"15","label":"地产公司物业对接人"},{"value":"16","label":"业委会成员"},{"value":"17","label":"热心业户"}],
        uploadUrl: Common.getBaseUrl() + 'admin/Customer/uploadFile?login_name=' + window.localStorage.getItem('login') + '&token=' + window.localStorage.getItem('token'),
        uploadData: {},
        project_list:[]
      }
    },
    mounted() {
      this.getProjectList();
      this.form = this.getFormData(this.form_data)
      this.old_form = this.getFormData(this.form_old_data)
      //this.form,this.old_form
      console.table([this.form, this.old_form])
    },
    methods: {
      getFormData(data) {

        let members = [
          {name: '', sex: '', birthday: '', job: '法定代表人', id_code: '', contact_number: '', interest: '', title: ''},
          {name: '', sex: '', birthday: '', job: '总经理', id_code: '', contact_number: '', interest: '', title: ''},
          {name: '', sex: '', birthday: '', job: '财务部经理', id_code: '', contact_number: '', interest: '', title: ''},
          {name: '', sex: '', birthday: '', job: '行政部经理', id_code: '', contact_number: '', interest: '', title: ''},
        ]

        let object = {
          id: 0,
          name: '',
          legal_person: '',
          business_code: '',
          registered_captial: '',
          establishment_date: '',
          business_term: '',
          business_scope: '',
          bank_name: '',
          bank_account: '',
          address: '',
          business_tel: '',
          business_license: '',
          ic_card: '',
          enterprise_class: '',
          registered_address: '',
          contact_name: '',
          contact_number: '',
          phone_number: '',
          fax: '',
          organization: '',
          property_type: [],
          email: '',
          post_address: '',
          post_code: '',
          type: [],
          attachment: [],
          special: '',
          invoice_title: '',
          tax_code: '',
          credit_limit: '',
          remark: '',
          members: members,
        }

        let newData = Object.assign({}, object, data)

        for(let k in newData) {
          if(newData[k] === null) newData[k] = ''
        }

        newData.attachment ? newData.attachment = [] : newData.attachment = JSON.parse(newData.attachment)
        newData.members = newData.members ? members : JSON.parse(newData.members)

        if(typeof newData.property_type == 'string') newData.property_type = newData.property_type.split(',')
        if(typeof newData.type == 'string') newData.type = newData.type.split(',')

        newData.enterprise_class === 0 ? newData.enterprise_class = '' : newData.enterprise_class += ''
        newData.category === 0 ? newData.category = '' : newData.category += ''
        newData.establishment_date = newData.establishment_date === 0 ? '' : Common.timeFormat(newData.establishment_date)
        newData.special = newData.special === 0 ? '' : newData.special + ''

        return newData
      },

      getData() {

        if(this.id > 0) {
          this.loading = true
          this.$myhttp.get('admin/Customer/getEnterpriseBasicInfo?customer_id='+this.id).then(backdata => {
            let res = backdata.data
            if(res.code == 200) {
              this.form = this.getFormData(res.data)
              this.form_old = this.getFormData(res.data)
            } else {
              this.$message.error('获取客户信息出错！');
            }
            this.loading = false
          })
        } else {
          this.form = this.getFormData({})
          this.form_old = this.getFormData({})
        }

      },
      submitForm(formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {

            let data = Object.assign({}, this.form);

            if(!data.organization_project_id){
              window.alert("请选择归属组织（项目）");
              return false;
            }

            data.members = JSON.stringify(data.members)
            data.attachment = JSON.stringify(data.attachment.map(item => {
              return {
                name: item.name,
                url: item.url,
              }
            }))
            data.type = data.type.join(',')
            data.property_type = data.property_type.join(',')

            let old_data = Object.assign({}, this.form_old)
            old_data.members = JSON.stringify(old_data.members)
            old_data.attachment = JSON.stringify(old_data.attachment.map(item => {
              return {
                name: item.name,
                url: item.url,
              }
            }))
            old_data.type = old_data.type.join(',')
            old_data.property_type = old_data.property_type.join(',')

            if(JSON.stringify(data) === JSON.stringify(old_data)) {
              this.$message.warning('数据未修改，无需提交！');
              return false;
            }
            data.old_form = JSON.stringify(old_data);

            this.$myhttp.post('admin/Customer/saveEnterpriseBasic', data).then(backdata => {
              let res = backdata.data

              this.$message({
                message: res.msg,
                type: res.code == 200 ? 'success' : 'error'
              })

              if(res.code == 200) {
                this.$emit('callback', res.customer_id)
              }

              this.$Loading.finish();
            });

          } else {
            return false;
          }
        });
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      filePreview(file) {

        let url = Common.getBaseUrl() + 'storage/' + file.url
        let a = document.createElement('a')
        a.href = url
        a.target = '_blank'//在新窗口打开
        a.click();

      },
      uploadRemove(file, fileList) {
        this.setAttachmentData(fileList)
      },
      setAttachmentData(fileList) {
        this.form.attachment = fileList.map(item => {
          return {name: item.name, url: item.url ? item.url : item.response.data}
        })
      },
      uploadSuccess(response, file, fileList) {
        this.setAttachmentData(fileList)
      },
      getProjectList(){
        const that=this;
        ERP.getRequest({
          url:"admin/Project/getProjectList",
          data:{}
        },ret=>{
          if(ret.code){
            that.project_list=ret.data;
          }
        })
      },
      diffData(val1, val2) {
        return JSON.stringify(val1)!== JSON.stringify(val2)
      },
    },
    watch: {
      form_data: {
        handler(newVal, oldVal) {
          this.form = this.getFormData(newVal||{})
        },
        deep: true
      },
      form_old_data: {
        handler(newVal, oldVal) {
          this.old_form = this.getFormData(newVal||{})
        },
        deep: true
      },
    },
  }
</script>

<style lang="scss" scoped>

  @import "../../common.scss";

  .member-title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
  }

  .el-date-editor.el-input {
    width: auto;
  }
  .diff-form {
    border: 1px solid #ff3d00;
    color: #ff3d00;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/preview/enterprise-preview.vue